import {useState} from 'react';
import {updateReplacementDate, updateReplacementDateQuery} from '../services/replacement.service';

export const useLaptopReplacementAsync = () => {
    const [isUpdateReplacementLoading, setIsUpdateReplacementLoading] = useState<boolean>(false);

    const postReplacementDate = (query: updateReplacementDateQuery) => {
        setIsUpdateReplacementLoading(true);
        return updateReplacementDate(query).finally(() => {
            setIsUpdateReplacementLoading(false);
        });
    };

    return {
        postReplacementDate,
        isUpdateReplacementLoading,
    };
};